
import { ref, defineComponent } from 'vue'
import ModalBase from '../genenral/ModalBase.vue'
import smoothscroll from 'smoothscroll-polyfill'
export default defineComponent({
  name: 'MovieModal',
  components: {
    ModalBase
  },
  props: {
    modelValue: Boolean,
    movies: Array,
    title: String
  },
  setup() {
    smoothscroll.polyfill()
    const player = ref<any>(undefined)
    const selectedMovie = ref<any>(undefined)
    const selectMovie = (movie: any) => {
      selectedMovie.value = movie
      player.value.scrollIntoView({ behavior: 'smooth' })
    }
    return {
      player,
      selectedMovie,
      selectMovie
    }
  }
})
